/** @jsxImportSource @emotion/react */
import Typography from '@mui/material/Typography'
import { format } from 'date-fns'
import { FC } from 'react'
import * as classes from './styles'

export type Revision = {
  updatedBy: string
  updatedAt: string
}

type RevisionsProps = {
  revisions: Revision[]
  className?: string
  hideTitle?: boolean
  editOnly?: boolean
}

export const Revisions: FC<RevisionsProps> = ({ revisions, className, hideTitle, editOnly }) => {
  if (!revisions.length) {
    return null
  }

  return (
    <div css={classes.content} className={className} data-testid="revisions">
      {!hideTitle && (
        <Typography css={classes.title} variant="h6">
          Revisions
        </Typography>
      )}
      <div css={classes.separator} />
      <div css={classes.list} data-testid="revisions-list">
        {[...revisions].reverse().map(({ updatedBy, updatedAt }, index) => {
          const updatedAtDate = new Date(updatedAt)
          return (
            <div key={updatedAt} data-testid={`revision-${index}`}>
              <span css={classes.username}>{updatedBy}</span>{' '}
              {!editOnly && index === revisions.length - 1 ? 'created' : 'edited'} this{' '}
              <span css={classes.datetime}>{format(updatedAtDate, 'd LLLL, yyyy ')}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
